import axios from '../../apis/apicidtech';
import { types } from '../../types/types';
import { getToken } from '../../utils/tokencidtechapi';
import { dispatchpending, dispatchresponse, dispatchresponseerror } from '../utils/dispatches';

export const inicialogin = () => {
    return async dispatch => {
        dispatch({
            type: types.LOGIN.INICIALOGIN,
            payload: {}
        })
    }
}

export const validaacesso = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/usuarios/login',{
                headers: {
                    Accept: 'application/json'
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGIN.VALIDAACESSO);

            return response.data;
        }catch(error){            
            if(error.response.status === 401 && error.response.statusText === 'Unauthorized'){
                dispatchresponse(dispatch, {result: false},types.LOGIN.VALIDAACESSO);
            }else{
                dispatchresponseerror(dispatch, error);
            }
        }
    }
}

export const codigoresetsenha = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/usuarios/resetsenha',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGIN.CODIGO_RESETSENHA);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const codigovalidacacadastro = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/usuarios/codigovalidacao',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGIN.CODIGO_VALIDACAD);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const validacacadastro = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/usuarios/validacao',
                { 
                    ...dados
                },
                {
                    headers: {
                        Accept: 'application/json',                    
                        Authorization: `Bearer ${getToken()}`
                    }
                }                
            );

            dispatchresponse(dispatch, response.data,types.LOGIN.VALIDACAD);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const pesquisa = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/usuarios/pesquisa',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGIN.PESQUISA);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const pesquisacodigo = (filtro = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.get('credenciamento/usuarios/pesquisa/codigo',{
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                },                
                params: { 
                    ...filtro
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGIN.PESQUISA);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const atualiza = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/usuarios/atualiza',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGIN.ATUALIZALOGIN);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}

export const atualizasenha = (dados = {}) => {
    return async dispatch => {

        dispatchpending(dispatch);
        
        try{
            const response = await axios.put('credenciamento/usuarios/atualiza/senha',
            {
                ...dados
            },
            {
                headers: {
                    Accept: 'application/json',                    
                    Authorization: `Bearer ${getToken()}`
                }
            });

            dispatchresponse(dispatch, response.data,types.LOGIN.ATUALIZALOGIN);

            return response.data;
        }catch(error){
            dispatchresponseerror(dispatch, error);
        }
    }
}
